export default class KdiagramCalculationResultLineParametersData {
  constructor(
    rpmPowerLineAParameter,
    rpmPowerLineBParameter,
    rpmSpeedLineAParameter,
    rpmSpeedLineBParameter,
    stwPowerLineAParameter,
    stwPowerLineBParameter,
    stwRpmLineAParameter,
    stwRpmLineBParameter,
    r2RpmPower,
    r2RpmSpeed,
  ) {
    this.rpmPowerLineAParameter = rpmPowerLineAParameter;
    this.rpmPowerLineBParameter = rpmPowerLineBParameter;
    this.rpmSpeedLineAParameter = rpmSpeedLineAParameter;
    this.rpmSpeedLineBParameter = rpmSpeedLineBParameter;
    this.stwPowerLineAParameter = stwPowerLineAParameter;
    this.stwPowerLineBParameter = stwPowerLineBParameter;
    this.stwRpmLineAParameter = stwRpmLineAParameter;
    this.stwRpmLineBParameter = stwRpmLineBParameter;
    this.r2RpmPower = r2RpmPower;
    this.r2RpmSpeed = r2RpmSpeed;

  }

}
